import {
    ISchedulerOneTimeTask,
    ISchedulerDailyTask,
    ISchedulerWeeklyTask,
    ISchedulerMonthlyTask,
    ISchedulerMonthlyDayOfWeekTask
} from './../../typings/board/Models';
import { IPromise } from 'angular';
import { IQService } from 'angular';
import { IHttpService, IHttpPromise } from 'angular';
import { ITimeZoneAndCurrent } from "../../typings/board/ControllerResponse";
import { DaysOfTheWeek, MonthsOfTheYear, WhichWeek } from "../../typings/board/TaskScheduler";
import { ISchedulerTask } from "../../typings/board/Models";

export const SCHEDULER_SERVICE = "schedulerService";

export class SchedulerService {
    static $inject = ["$http", "$q"];
    constructor(private $http: IHttpService, private $q: IQService) { }

    getActualServerTime(): IPromise<ITimeZoneAndCurrent> {
        return this.$http.get<ITimeZoneAndCurrent>("api/scheduler/getActualServerTime").then(response => response.data);
    }

    days(): IPromise<DaysOfTheWeek[]> {
        return this.$http.get<DaysOfTheWeek[]>("api/scheduler/days").then(response => {
            return response.data;
        });
    }

    months(): IPromise<MonthsOfTheYear[]> {
        return this.$http.get<MonthsOfTheYear[]>("api/scheduler/months").then(response => {
            return response.data;
        });
    }

    weeks(): IPromise<WhichWeek[]> {
        return this.$http.get<WhichWeek[]>("api/scheduler/weeks").then(response => {
            return response.data;
        });
    }

    tasks(): IPromise<ISchedulerTask[]> {
        return this.$http.get<ISchedulerTask[]>("api/scheduler/gettasks").then(response => {
            return response.data;
        });
    }

    task(taskName: string): IPromise<ISchedulerTask> {
        return this.$http.get<ISchedulerTask>("api/scheduler/gettask", { params: { taskName: taskName } }).then(response => {
            return response.data;
        });
    }

    removeTask(taskName: string): IHttpPromise<void> {
        return this.$http.post<void>("api/scheduler/removetask", `=${taskName}`, { headers: { "Content-Type": "application/x-www-form-urlencoded" } });
    }

    toggleTriggerEnabled(taskName: string, triggerEnabled: boolean): IPromise<void> {
        return this.$http.get<void>("api/scheduler/ToggleTriggerEnabled", { params: { taskName: taskName, triggerEnabled: triggerEnabled } }).then(response => {
            return response.data;
        });
    }

    stopTrigger(taskName: string): IPromise<void> {
        return this.$http.get<void>("api/scheduler/stoptrigger", { params: { taskName: taskName } }).then(response => {
            return response.data;
        });
    }

    oneTime(task: ISchedulerOneTimeTask, oldName?: string): IPromise<ISchedulerTask> {
        return this.$http.post<ISchedulerTask>('api/scheduler/onetime', task, { params: { originalName: oldName } }).then(response => {
            return response.data;
        }, reason => this.$q.reject(reason.data.message));
    }

    daily(task: ISchedulerDailyTask, oldName?: string): IPromise<ISchedulerTask> {
        return this.$http.post<ISchedulerTask>(
            'api/scheduler/daily', task, { params: { originalName: oldName } }).then(response => {
                return response.data;
            }, reason => this.$q.reject(reason.data.message));
    }

    weekly(task: ISchedulerWeeklyTask, oldName?: string): IPromise<ISchedulerTask> {
        return this.$http.post<ISchedulerTask>(
            'api/scheduler/weekly', task, { params: { originalName: oldName } }).then(response => {
                return response.data;
            }, reason => this.$q.reject(reason.data.message));
    }

    monthly(task: ISchedulerMonthlyTask, oldName?: string): IPromise<ISchedulerTask> {
        return this.$http.post<ISchedulerTask>(
            'api/scheduler/monthly', task, { params: { originalName: oldName } }).then(response => {
                return response.data;
            }, reason => this.$q.reject(reason.data.message));
    }

    monthlyDow(task: ISchedulerMonthlyDayOfWeekTask, oldName?: string): IPromise<ISchedulerTask> {
        return this.$http.post<ISchedulerTask>('api/scheduler/monthlyDow', task, { params: { originalName: oldName } }).then(response => {
            return response.data;
        }, reason => this.$q.reject(reason.data.message));
    }
}



// WEBPACK FOOTER //
// ./app/scheduler/scheduler.service.ts